import { jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styles from '../../styles/Progress.module.css';
export function XpAnimation({ xp, trigger }) {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (trigger === 0)
            return;
        setVisible(true);
        const timer = setTimeout(() => setVisible(false), 1500);
        return () => clearTimeout(timer);
    }, [trigger]);
    if (!visible || xp <= 0)
        return null;
    return (_jsxs("div", { className: styles.xpFloat, children: ["+", xp, " XP"] }));
}
